// extracted by mini-css-extract-plugin
export default {"loader":"Gj58qB"};